<template>
	<div class="sf-table">
		<table class="qms-table">
			<tbody>
				<tr>
					<!--검사일-->
					<th class="col-1">* {{ getMessage_('QWCC001390') }}</th>
					<!--검사차수-->
					<th class="col-1">{{ getMessage_('QWCC001911') }}</th>
					<!--검사항목수-->
					<th class="col-1">{{ getMessage_('QWCC001374') }}</th>
					<!--적합항목수-->
					<th class="col-1">{{ getMessage_('QWCC001375') }}</th>
					<!--부적합항목수-->
					<th class="col-1">{{ getMessage_('QWCC001376') }}</th>
					<!--검사원-->
					<th class="col-1">{{ getMessage_('QWCC000009') }}</th>
					<!--작성일-->
					<th class="col-1">{{ getMessage_('MWCC000849') }}</th>
					<!--파일첨부-->
					<th rowspan="2" class="col-1">{{ getMessage_('QWCC000039') }}</th>
					<td rowspan="2" class="col-3">
						<file-upload-list
							id="fileList"
							:propFileList="resultFileList_"
							@MultiFile="multiFile"
							:isEditable="isFiledDisabled()"
							maxQuantity="10"
							width="100%"
							height="100px"
							@onDownload="onDownloadFile"
						></file-upload-list>
					</td>
				</tr>
				<tr>
					<!--시작일자-->
					<td class="col-1">
						<el-date-picker
							:value="resultMaster.newInsnDd?.replaceAll('-', '')"
							format="yyyy-MM-dd"
							value-format="yyyyMMdd"
							:disabled="true"
							@input="value => onChange({ key: 'newInsnDd', value })"
						/>
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.newIpnNos" readOnly />
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.insnPrvsCt" readOnly />
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.okPrvsCt" readOnly />
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.ngPrvsCt" readOnly />
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.pprrNm" readOnly />
					</td>
					<td class="col-1">
						<el-input v-model="resultMaster.pprrDd" readOnly />
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/pqy/ptin/PowTourRgst/store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		FileUploadList
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		isFiledDisabled() {
			if (this.resultMaster.pprrDd != '' && this.resultMaster.pprrDd != null) {
				return false;
			} else {
				return true;
			}
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		multiFile(files, delFiles) {
			//console.log('부모창', files, delFiles);
			this.setState_({ key: 'fileList', value: files });
			this.setResultMaster_({ key: 'fileList', value: files });

			//console.log('전달확인', this.fileList);
		},
		async onChange({ key, value }) {
			this.setResultMaster_({ key, value });
		}
	}
};
</script>

<style></style>
